import React from 'react';
import PropTypes from 'prop-types';
import popup from '../../../popup';
import './style.scss';
import '~/assets/css/fitness-globals.scss';
import Slider from 'react-slick';
import Img1 from './onboarding-1.png';
import Img2 from './onboarding-2.png';
import Img3 from './onboarding-3.png';
import Logo from './logo.png';

class OnboardingScreen extends React.Component {

	constructor(props){
		super(props);
		this.redirectToSignIn = this.redirectToSignIn.bind(this);
	}

	redirectToSignIn(){
		this.props.onClose();
		popup.fitnessSignInCreate({
			showCloseButton: false
		});
	}

	render() {
		return (
			<div className="onboarding-screen fitness-modal">
				<div className="close-button" onClick={this.props.onClose}><i className="ion-ios-close-empty"/></div>
				<img className="logo-image" src={Logo} alt="Logo" />
				<div className="carousel">
	              <Slider
	                dots={true}
	                infinite={false}
	                arrows={false}
	                slidesToShow={1}>
	                <div>
	                	<div className="onboarding-slide">
	                		<p>Unlimited access to the fastest<br/>growing library of fitness concepts<br/>from the world's elite instructors.</p>
	                		<img alt="onboarding_image" src={Img1}/>
	                	</div>
	                </div>
	               	<div>
	                	<div className="onboarding-slide"> 
	                		<p>Live and On Demand.<br/>Experience the best workouts<br/>anytime, anywhere, on any device.</p>
	                		<img alt="onboarding_image" src={Img2}/>
	                	</div>
	                </div>
	                <div>
	                	<div className="onboarding-slide">
	                		<p>Your journey to a new you<br/>starts now</p>
	                		<img alt="onboarding_image" src={Img3}/>
	                	</div>
	                </div>
	              </Slider>
	            </div>
				<button className="primary-button black" onClick={this.redirectToSignIn}>CREATE A FREE ACCOUNT</button>
				<div className="sub-ctas">
					<a onClick={this.redirectToSignIn}>SIGN IN</a>
				</div>
		  	</div>
		)
	}

}

OnboardingScreen.propTypes = {
  onClose: PropTypes.func
};

export default OnboardingScreen;